import { xml2ast, allHtmlParsers, parseChildren } from '@utils/ast';
import { video23Parsers } from '../../ast/spec.23video.js';
import { boxParsers } from '../../ast/spec.box.js';
import { fontParsers } from '../../ast/spec.font.js';
import { parseIGuideHtmlNode } from '../../ast/spec.html.js';
import { imageParsers } from '../../ast/spec.image.js';
import { linkParsers } from '../../ast/spec.link.js';
import { medialibraryParsers } from '../../ast/spec.medialibrary.js';
import { preparseCustomBlockTags } from '../../ast/util.prepare-custom-block-tag.js';

function iGuideHtmlToPrintAST(html) {
  return xml2ast(preparseCustomBlockTags(html, ["factbox", "quotebox", "questionbox"]).replace(/\[(audio|video) id="([^"]+)"\]/gi, '<medialibrary$1 id="$2" />').replace(/\[23-video id="(.+?)"+?\]/gi, '<video23 data="$1" />'), {
    ...htmlNodeParsers,
    ...fontParsers,
    ...boxParsers,
    ...video23Parsers
  }, "text/html");
}
const parseIGuideHtmlPrintNode = (node, context) => {
  const attributes = Object.fromEntries(Array.from(node.attributes).map(it => [it.nodeName, it.nodeValue]).filter(it => it[1] !== null));
  const children = parseChildren(node, {
    ...htmlNodeParsers,
    ...video23Parsers,
    ...medialibraryParsers,
    ...boxParsers,
    ...imageParsers,
    ...fontParsers,
    ...linkParsers
  }, context.depth + 1);
  const tagName = node.tagName.toLowerCase();
  const transformedTagName = (() => {
    switch (tagName) {
      // Add a parser that can transform legacy
      // <a class="flowplayer-..." />-tags used to embed audio and video files
      // into modern <audio />- and <video/>-tags.
      case "a":
        if (node.classList.contains("flowplayer-video")) {
          return "video";
        }
        if (node.classList.contains("flowplayer-audio")) {
          return "audio";
        }
        break;

      // downgrade h1,h2,h3 tags to h4 in order to ensure that heading levels
      // are WCAG-compliant, as h1-h3 are reserved for other use-cases in the
      // frontend
      case "h1":
      case "h2":
      case "h3":
        return "h4";
    }
    return tagName;
  })();
  if (node.matches(".richtext--image-wrapper")) {
    const imageNode = node.querySelector("img");
    const captionNode = node.querySelector(".richtext--image-caption");
    const parsedImageNode = imageNode ? imageParsers.img(imageNode, context) : undefined;
    if (parsedImageNode) {
      return {
        ...parsedImageNode,
        caption: captionNode ? parseIGuideHtmlNode(captionNode, context) ?? undefined : undefined
      };
    }
  }
  if (transformedTagName === "table") {
    attributes["data-avoid-break-inside"] = "true";
  }
  return {
    nodeType: "html",
    tagName: transformedTagName,
    attributes: Object.keys(attributes).length > 0 ? attributes : undefined,
    children: children.length > 0 ? children : undefined
  };
};
const htmlNodeParsers = {
  ...Object.fromEntries(Object.keys(allHtmlParsers).map(key => [key, parseIGuideHtmlPrintNode])),
  iframe: () => null,
  audio: () => null,
  video: () => null
};

export { iGuideHtmlToPrintAST };
//# sourceMappingURL=ast.content-to-ast.js.map
